@if (buttonVisible) {
    @for (panel of _availablePanels; track panel) {
        <lg-button
            [isDisabled]="_disabled"
            [icon]="panel.icon || ''"
            [textLc]="panel.nameLc"
            (click)="_togglePanel(panel)"
            style="margin-left: 10px"
        />
    }
}
